import { render, staticRenderFns } from "./DialogueItem.vue?vue&type=template&id=16e918aa&scoped=true&"
import script from "./DialogueItem.vue?vue&type=script&lang=js&"
export * from "./DialogueItem.vue?vue&type=script&lang=js&"
import style0 from "./DialogueItem.vue?vue&type=style&index=0&id=16e918aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e918aa",
  null
  
)

export default component.exports